import { useGetAgencyDetails } from '@urbanx/agx.agencies.client';
import { AgxButton, AgxSpacer, Icon_Arrow } from '@urbanx/agx.ui-components2';
import { useNavigationHistory } from 'hooks/useNavigationHistory';
import { Link } from 'react-router-dom';
import * as styles from './BackButton.css';

const BackButton = () => {
  const { to, state, title, agencyId } = useNavigationHistory();
  const { data: agency } = useGetAgencyDetails(agencyId!, !!agencyId);
  const destination = agencyId ? `${agency?.name ?? 'Agency'} / ${title}` : title;

  return (
    <AgxButton
      id="btn-back"
      variant="linkBrand"
      className={styles.backButton}
      wrapperClassName={styles.wrapper}
      text={
        <AgxSpacer direction="horizontal" gap="spacing-md" contentAlignment="center">
          <Icon_Arrow direction="left" width={22} height={22} />
          {`Back to ${destination}`}
        </AgxSpacer>
      }
      renderLink={(props) => <Link {...props} to={to} state={state} />}
    />
  );
};

export default BackButton;
